export default "__VITE_ASSET__DGJySDsg__"